enum AnalysisMode {
	MATH = 'MATH',
	TEXT = 'TEXT'
}

export default AnalysisMode;


// WEBPACK FOOTER //
// ./code/project/modules/parsing/AnalysisMode.ts